import { Card, Tag, Typography, Space } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface Props {
  stepNumber: number;
  totalSteps: number;
  title: string;
  description?: string;
  notes?: string;
}

/**
 * Generic placeholder for wizard steps that have not been implemented yet.
 * Renders the step title + a "TODO: implementează" hint so the wizard
 * can be navigated end-to-end while real screens are developed.
 */
const StepPlaceholder = ({ stepNumber, totalSteps, title, description, notes }: Props) => {
  return (
    <Card
      bordered
      style={{ borderRadius: 8 }}
      title={
        <Space>
          <ExperimentOutlined style={{ color: '#1890ff' }} />
          <span>Pas {stepNumber} / {totalSteps}</span>
          <Tag color="orange">TODO</Tag>
        </Space>
      }
    >
      <Title level={3} style={{ marginTop: 0 }}>{title}</Title>
      {description && (
        <Paragraph type="secondary">{description}</Paragraph>
      )}
      <Paragraph>
        <Text strong>TODO:</Text> implementează conținutul pentru acest pas.
      </Paragraph>
      {notes && (
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          <Text italic>{notes}</Text>
        </Paragraph>
      )}
    </Card>
  );
};

export default StepPlaceholder;
